import { Body, Record } from '../types';
/**
 * @param headers
 *
 * @returns Returns array with headers
 */
function parseHeaders(headers: string) {
  const splittedHeaders: Array<string> = headers.split('\r\n');
  const filteredHeaders = splittedHeaders.filter((header) => {
    const [name, value] = header.split(':');
    return value && name;
  });

  return filteredHeaders.map((header) => {
    const [name, value] = header.split(':');
    return {
      name: name.trim(),
      value: value.trim(),
    };
  });
}

/**
 * @param body
 */
function isJsonTypeBody(body: Body): boolean {
  if (typeof body === 'string') {
    try {
      JSON.parse(body);

      return true;
    } catch {
      return false;
    }
  }

  return false;
}

/**
 * @param record
 */
function isRecordWithBody(record: Record): boolean {
  return Boolean(record.body);
}

export { parseHeaders, isRecordWithBody, isJsonTypeBody };
